import type { Handle } from '../contracts/handles';

/**
 * Выводит бренд ручки/крючка для подбора магазинов (Блок 4, ADR-0089 §4.2,
 * «СТРОГОЕ ПРАВИЛО» §2 п.2/п.6). Pure.
 *
 * - реальный бренд (`GTV`/`Boyard`/`Hafele`/…) → возвращаем VERBATIM (P-001);
 * - SKU-плейсхолдеры «Не известно N» имеют `brand=''` (ADR-0070 §4), а маркер
 *   «не известно 1/2» лежит в `Global_ID` (PK, verbatim) → выводим магазин-бренд:
 *   «не известно 1» → `'АГИ'` (магазин Аги), «не известно 2» → `'ВЕК'` (BEK
 *   Furniture fittings). CI по обеим формам регистра (lowercase-ручки `не известно`
 *   + Caps-крючки `Не известно`, Q-B: распространяется на все 1936 SKU);
 * - иначе (нет бренда и нет маркера) → `null` → эндпоинт вернёт пустой список
 *   магазинов (empty-fallback, P-021).
 *
 * P-001: `Global_ID` НЕ мутируется — только читается для вывода бренда.
 */
export function resolveHandleFittingBrand(handle: Handle): string | null {
  if (handle.brand.trim()) return handle.brand;
  const gid = handle.globalId.toLowerCase();
  if (gid.includes('не известно 1')) return 'АГИ';
  if (gid.includes('не известно 2')) return 'ВЕК';
  return null;
}
